import React, { useState, useEffect } from 'react';
import './FormStyles.css';
import StepDrawer from './StepDrawer';
import { helpers } from '../services/helpers';
import StarRating from './StarRating';

function ReviewForm({
  submitting,
  formData,
  setFormData,
  onSubmit,
  currentStep,
  totalSteps,
  onBack,
  onCancel
}) {

  return (
    <StepDrawer
      currentStep={currentStep}
      totalSteps={totalSteps}
      onCancel={onCancel}
      onContinue={onSubmit}
      title={
        <span>Additional Details <span style={{ color: '#9BA3AF' }}>(Optional)</span></span>
    }
      onBack={onBack}
      disabled={submitting}
    >
      <div className="form-content">


        <div className="review-row">
          <div className="review-label">
            Additional details:
          </div>
        </div>
        <div className="review-row-large">
          <textarea
            className="review-value"
            value={formData.description}
            onChange={(e) => setFormData(prev => ({
              ...prev,
              description: e.target.value
            }))
            }
            placeholder="Anything else about your surgery or recovery that you want to share..."
          />
        </div>
      </div>
    </StepDrawer>
  );
}

export default ReviewForm; 